import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import About from "./About";
import * as API from "../../../utils/api.service";
import { TOAST_ERROR } from "../../../utils/common.service";
import SearchAndExport from "../../../component/SearchAndExport";
import Pagination from "../../../component/Pagination";
import { ITEM_PER_PAGE, PUBLIC_URL, SEARCH_DELAY } from "../../../app.config";
import useDebounce from "../../hooks/useDebounce";
import { useDispatch } from "react-redux";
import { setLoader } from "../../../Store/slices/MasterSlice";

export default function ViewSchoolDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  // const schoolData = location?.state?.schoolData;
  const [step, setStep] = useState(1);
  const [teacherDeatils, setTeacherDeatils] = useState({});
  const [ActivityDeatils, setActivtyDeatils] = useState([]);
  const [search, setSearch] = useState("");
  const debounce = useDebounce(search, SEARCH_DELAY);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  let dispatch = useDispatch();
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const { schoolData } = location.state || {};
 // console.log("iiiiiiiiiiiiiiiiiiiiiiiiiiii",schoolData);
  

  useEffect(() => {
    const fetchUser = async () => {
      try {
        let request = {
          id: schoolData?.id,
          search: debounce,
          page: page,
        };
        dispatch(setLoader(true));
        const response = await API.getSchoolTeacherListApi(request);
        //console.log("response----------------------------",response.data);
        
        setTeacherDeatils(response.data);
        if (response?.data?.code === "1") {
          dispatch(setLoader(false));
        } else {
          dispatch(setLoader(false));
        }
      } catch (error) {
        dispatch(setLoader(false));
        TOAST_ERROR("Failed to load User Details");
      }
    };

    fetchUser();
  }, [schoolData?.id, debounce, page, dispatch]);

  const handleStepChange = (newStep) => setStep(newStep);
  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <>
            <About schoolData={schoolData} />
          </>
        );
      case 2:
        return <>{/* <Teams schoolData={schoolData} /> */}</>;
      case 3:
        return <>{/* <Employee schoolData={schoolData} /> */}</>;
      case 4:
        return (
          <>
            {/* <DonateNow isLoader={isLoader} setIsApiCall={setIsApiCall} /> */}
          </>
        );
      default:
        return null;
    }
  };

  //console.log(totalCount, "==========================");

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          {/* start page title */}
          <div className="row">
            <div className="col-sm-12" style={{ marginTop: "150px" }}>
              <div className="profile-user-box">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="profile-user-img">
                      <img
                        src={schoolData?.profile_image}
                        alt=""
                        className="avatar-lg rounded-circle"
                      />
                    </div>
                    <div className="">
                      <h4 className="mt-4 fs-17 ellipsis">
                        {schoolData?.name}
                      </h4>
                      <p className="font-13">{schoolData?.email}</p>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    {/* <div className="d-flex justify-content-end align-items-center gap-2">
                      <button
                        type="button"
                        className="btn btn-soft-danger"
                        onClick={() =>
                          navigate(`/manage_client/edit_client`, {
                            state: { schoolData },
                          })
                        }
                      >
                        <i className="ri-settings-2-line align-text-bottom me-1 fs-16 lh-1" />
                        Edit Profile
                      </button>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* end row */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card p-0">
                <div className="card-body p-0">
                  <div className="profile-content">
                    <ul className="nav nav-underline nav-justified gap-0">
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          data-bs-toggle="tab"
                          data-bs-target="#aboutme"
                          type="button"
                          role="tab"
                          aria-controls="aboutme"
                          aria-selected="true"
                          href="#aboutme"
                        >
                          About
                        </a>
                      </li>
                      
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-bs-toggle="tab"
                          data-bs-target="#projects"
                          type="button"
                          role="tab"
                          aria-controls="projects"
                          aria-selected="false"
                          href="#projects"
                        >
                          Teacher
                        </a>
                      </li>
                    </ul>

                    <div className="tab-content m-0 p-4">
                      <div
                        className="tab-pane active"
                        id="aboutme"
                        role="tabpanel"
                        aria-labelledby="aboutme-tab"
                        tabIndex={0}
                      >
                        {/* About Me Content */}
                        <div className="profile-desk">
                          <h5 className="text-uppercase fs-17 text-dark">
                            Address
                          </h5>
                          <div className="designation mb-4">
                          {schoolData?.address ? schoolData.address : "N/A"}
                          </div>
                          <h5 className="text-uppercase fs-17 text-dark">
                           Phone No.
                          </h5>
                          <div className="designation mb-4">
                          {schoolData?.phone ? schoolData.phone : "N/A"}
                          </div>
                         
                        </div>
                      </div>
                      {/* Activities Tab */}
                      <div
                        className="tab-pane"
                        id="projects"
                        role="tabpanel"
                        aria-labelledby="projects-tab"
                      >
                        <div className="rounded-3 mb-3">
                          <SearchAndExport
                            searchFieldName={`teacher`}
                            setSearch={setSearch}
                            isExport={false}
                          />
                        </div>
                        <div className="row m-t-10">
                          <div className="col-md-12">
                            <div className="table-responsive">
                              <table className="table table-bordered mb-0">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Teacher Name</th>
                                    <th>Image</th>
                                    <th>Email</th>
                                    <th>Phone No</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>  
                                <tbody>
                                  {teacherDeatils &&
                                  teacherDeatils.length > 0 ? (
                                    teacherDeatils.map((teacherDeatil, index) => (
                                      <tr key={teacherDeatil?.id || index}>
                                        <td>{index + 1}</td>
                                        <td>{teacherDeatil.name}</td>
                                       
                                        <td>
                              
                                            <img
                                              src={
                                                teacherDeatil.profile_image
                                              }
                                              alt="Activity"
                                              style={{
                                                width: "100px",
                                                height: "auto",
                                              }}
                                            />
                                         
                                        </td>
                                        <td>
                                        <td>{teacherDeatil?.email ? teacherDeatil.email : "N/A"}</td>
                                        </td>
                                        <td>
                                          {teacherDeatil?.phone ||
                                            "N/A"}
                                        </td>
                                        <td>
                                          <span
                                            className={`badge ${
                                              teacherDeatil?.status ===
                                              "Active"
                                                ? "bg-success"
                                                : "bg-warning"
                                            }`}
                                          >
                                            {teacherDeatil?.status ||
                                              "Unknown"}
                                          </span>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="6" className="text-center">
                                        No Teacher found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                              <Pagination
                                per_page={ITEM_PER_PAGE}
                                totalItems={totalCount}
                                onPageChange={handlePageChange}
                                page={page}
                                labelName={`Teacher`}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* end page title */}
        </div>
      </div>
    </>
  );
}
